import Vue from 'vue'
import Vuex from 'vuex'
import admin_filters from './modules/admin_filters'
import common from './modules/common'
import params from './modules/params'
import registration_lists from './modules/registration_lists'
import site_lists from './modules/site_lists'
import users from './modules/users'
import welcome_banner from './modules/welcome_banner'
import datatable from './modules/datatable'
import datatable_columns from './modules/datatable_columns'
import campaigns from './modules/campaigns'
import redirect from './modules/redirect'
// import VuexPersistence from 'vuex-persist'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'

const ls = new SecureLS({ isCompression: false })
const dataState = createPersistedState({
	key: `${process.env.PROJECT_FOLDER}-v1`,
	storage: {
		getItem: (key) => ls.get(key),
		setItem: (key, value) => ls.set(key, value),
		removeItem: (key) => ls.remove(key),
	},
	paths: [
		'admin_filters',
		'common',
		'registration_lists',
		'site_lists',
		'params',
		'welcome_banner',
		'datatable',
		'datatable_columns',
		'campaigns',
	],
})

// const vuexLocal = new VuexPersistence({
//     storage: window.localStorage,
//     reducer: state => ({
//         admin_filters: admin_filters,
//         common: state.common,
//         registration_lists: state.registration_lists,
//         site_lists: state.site_lists,
//         params: state.params,
//         welcome_banner: state.welcome_banner,
//         datatable: state.datatable,
//         datatable_columns: state.datatable_columns,
//         campaigns: state.campaigns
//     })
// })

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		admin_filters,
		common,
		params,
		registration_lists,
		site_lists,
		users,
		welcome_banner,
		datatable,
		datatable_columns,
		campaigns,
		redirect,
	},
	// plugins: [vuexLocal.plugin]
	plugins: [dataState],
})
